import React from 'react';

function Footer() {
    return (
        <footer className="bg-[#080808] border-t border-white/5 px-6 py-10">
            <div className="mx-auto max-w-7xl flex flex-col sm:flex-row sm:items-center justify-between gap-6">
                <div className="flex items-center gap-6">
                    <a href="/" className="text-white font-semibold text-sm no-underline">
                        Unit 326.
                    </a>
                    <span className="text-[#444] text-sm">Builders. Creatives.</span>
                </div>

                <div className="flex items-center gap-6">
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://twitter.com/Unit_326"
                        className="text-[#555] hover:text-white text-sm transition-colors no-underline"
                    >
                        Twitter
                    </a>
                    <a
                        href="mailto:hello@unit326.com"
                        className="text-[#555] hover:text-white text-sm transition-colors no-underline"
                    >
                        hello@unit326.com
                    </a>
                    <span className="text-[#444] text-sm">© 2026 Unit 326</span>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
